/**
 * Created by M.J. van der Werf <vanderwerf@bluehorizon.nl> on 6-11-18.
 */
const singleColumn = width => width === "xs" || width === "sm";

export default singleColumn;
